export default "__VITE_ASSET__D11Ot14D__"